import { takeLatest, put, call } from 'redux-saga/effects';

import { listIdentificadorCadastro } from '../service';
import {
  TABLE_IDENTIFICADOR_CADASTRO,
  TABLE_IDENTIFICADOR_CADASTRO_PENDING,
  TABLE_IDENTIFICADOR_CADASTRO_SUCCESS,
  TABLE_IDENTIFICADOR_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListIdentificadorCadastro(action) {
  yield put({ type: TABLE_IDENTIFICADOR_CADASTRO_PENDING })

  try {
    const table = yield call(listIdentificadorCadastro, action.args)
    yield put({ type: TABLE_IDENTIFICADOR_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_IDENTIFICADOR_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListIdentificadorCadastro() {
  yield takeLatest(TABLE_IDENTIFICADOR_CADASTRO, sagaListIdentificadorCadastro)
}